import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "stepIndicator", "errorMessage"]
  
  connect() {
    // Add smooth transitions for step changes
    this.addTransitionClasses()
  }
  
  addTransitionClasses() {
    // Add fade-in animation to visible steps
    this.stepTargets.forEach(step => {
      if (!step.classList.contains("hidden")) {
        step.classList.add("animate-fade-in")
      }
    })
  }
  
  // Optional: Client-side validation feedback
  validateCurrentStep(event) {
    const currentStep = this.element.querySelector('input[name="current_step"]').value
    const stepElement = this.stepTargets.find(step => !step.classList.contains("hidden"))
    
    if (!stepElement) return true
    
    // Find all required fields in current step
    const requiredFields = stepElement.querySelectorAll('[required]')
    let isValid = true
    
    requiredFields.forEach(field => {
      if (!field.value || field.value.trim() === '') {
        field.classList.add('input-error')
        isValid = false
      } else {
        field.classList.remove('input-error')
      }
    })
    
    if (!isValid && event) {
      // Show a subtle validation message
      this.showValidationMessage("Please fill in all required fields")
      event.preventDefault()
      return false
    }
    
    return true
  }
  
  showValidationMessage(message) {
    // Find or create error message element
    let errorDiv = this.element.querySelector('.step-validation-error')
    if (!errorDiv) {
      errorDiv = document.createElement('div')
      errorDiv.className = 'alert alert-warning mb-4 step-validation-error'
      const currentStep = this.stepTargets.find(step => !step.classList.contains("hidden"))
      if (currentStep) {
        currentStep.insertBefore(errorDiv, currentStep.firstChild)
      }
    }
    
    errorDiv.textContent = message
    errorDiv.classList.add('animate-fade-in')
    
    // Auto-remove after 3 seconds
    setTimeout(() => {
      errorDiv.classList.add('animate-fade-out')
      setTimeout(() => errorDiv.remove(), 300)
    }, 3000)
  }
  
  // Clear validation errors when user types
  clearFieldError(event) {
    event.target.classList.remove('input-error')
  }
}